export const PRODUCT_ATTACHMENT_TYPES = {
  IMAGE: 'image',
  PDF: 'pdf',
  RECIPE: 'video'
};

export const PDF_TYPES = {
  PRODUCT_ELEMENTS: 'stoixeia',
  PRODUCT_SPECIFICATIONS: 'prodiagrafes',
  VIDEOS: 'videos',
  INTERNAL_ONE: 'internalOne',
  INTERNAL_TWO: 'internalTwo',
  EXTERNAL_ONE: 'externalOne',
  PDF_FRONTPAGE_ONE: 'pdfFrontpageOne',
  PDF_FRONTPAGE_TWO: 'pdfFrontpageTwo',
  PDF_FRONTPAGE_THREE: 'pdfFrontpageThree',
  PDF_FRONTPAGE_FOUR: 'pdfFrontpageFour',
  PDF_FRONTPAGE_FIVE: 'pdfFrontpageFive',
};



// WEBPACK FOOTER //
// ./src/helpers/constants/productAttachmentTypes.js